export const signup = {
  buttons: {
    back: 'Retornar',
    next: 'Avançar',
  },
  userForm: {
    firstName: 'Nome',
    lastName: 'Sobrenome',
    document: 'CPF',
    phone: 'Telefone',
    email: 'E-mail',
    tooltip: {
      email:
        'Este é um dos nossos principais canais de comunicação com você. Insira um e-mail que você costuma acessar sempre.',
      phone:
        'Informações importantes sobre sua conta ou para resgatar sua senha futuramente poderão ser enviadas por SMS.',
    },
  },
  page: {
    signup: {
      title: 'Cadastro de acesso',
      subtitle: 'Se você já iniciou seu cadastro, finalize aqui.',
    },
    review: {
      title: 'Revise seus dados',
      subtitle: 'As informações abaixo estão corretas?',
      buttons: {
        changeInfo: 'Alterar informações',
        allRight: 'Tudo certo, podemos avançar',
      },
    },
    password: {
      title: 'Cadastre sua senha',
      subtitle: 'Cadastre a senha de acesso à plataforma.',
    },
  },
  success: {
    signUpConfirm: 'Cadastro efetuado com sucesso.',
  },
  errors: {
    required: 'Campo obrigatório',
    invalid: 'Campo inválido',
  },
};
